import { Stack, Tabs } from '@mantine/core';
import { Link } from 'react-router';
import { SEKME_ETIKET } from '../i18n/tr';

/**
 * MODÜL İÇİ SEKME ŞERİDİ (F4·S5·B1 — IA §4.1).
 *
 * Menü 22 satırdan 13'e inerken kapanan satırlar yok olmadı; **modülünün
 * içine sekme olarak girdi** (Bekleyen onaylarım → İşlerim · Talepler →
 * Aksiyonlar · Çalışma saatleri + Şiddet seviyesi → Olaylar · Organizasyon
 * ağacı → Organizasyon · Saha + Onay zincirleri + PTW yapılandırma → İş
 * izinleri).
 *
 * **SEKMELER ROTA TABANLIDIR, durum tabanlı değil:** her sekmenin kendi
 * adresi vardır (derin bağlantı + tarayıcı geri tuşu çalışır) ve eski
 * rotalar bu adreslere yönlendirilir — kırık bağlantı bırakılmaz.
 *
 * ⚠️ **`gizli` OLAN SEKME ÇİZİLMEZ ve kararı SUNUCU verir** (IA §3/4):
 * `my-authorization.yuzeyler`. Aynı liste sekmenin ucundaki `@RequireRole`
 * olduğu için görünmeyen sekmenin ucu da 403 verir; *"görüyorum ama
 * tıklayınca 403"* durumu doğmaz.
 *
 * ⚠️ **Sekme kimliği ETİKET DEĞİL ANAHTARDIR** — `data-testid` anahtardan
 * kurulur, böylece ad turları e2e'yi kırmaz.
 */
export interface Sekme {
  readonly key: string;
  readonly path: string;
  /** Sunucudan gelen görünürlük; `false` ise sekme HİÇ çizilmez. */
  readonly gorunur?: boolean;
}

export function ModulSayfasi({
  testId,
  sekmeler,
  aktif,
  children,
}: {
  testId: string;
  sekmeler: readonly Sekme[];
  aktif: string;
  children: React.ReactNode;
}): React.JSX.Element {
  const cizilecek = sekmeler.filter((sekme) => sekme.gorunur !== false);
  return (
    <Stack>
      <Tabs value={aktif} data-testid={testId}>
        <Tabs.List>
          {cizilecek.map((sekme) => (
            <Tabs.Tab
              key={sekme.key}
              value={sekme.key}
              // Mantine 9'da polimorfik `component` prop'u Tabs.Tab'ın
              // tipiyle uyuşmuyor; `renderRoot` gerçek <a> üretir — sekme
              // ORTA TIKLANABİLİR bir bağlantıdır, düğme değil.
              renderRoot={(props) => <Link to={sekme.path} {...props} />}
              data-testid={`sekme-${sekme.key}`}
            >
              {SEKME_ETIKET[sekme.key] ?? sekme.key}
            </Tabs.Tab>
          ))}
        </Tabs.List>
      </Tabs>
      {children}
    </Stack>
  );
}
